import React, { Component } from "react";
import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../api/apiConstant";
import { lang } from "../../config/lang";
import * as UTILS from "../../config/utils";
import { getVideoThumbFileName } from "../../config/utils";
import { setTimeout } from "timers";
import logApi from "../../api/logApi";

class NewsBlock extends Component {
  constructor(props) {
    super(props);

    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
    this.getNews = this.getNews.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }
    window.playVideo();

    setTimeout(this.ellipsisStyle, 400);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentDidUpdate() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }
    window.playVideo();

    setTimeout(this.ellipsisStyle, 400);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {}

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#desc_" + this.props.business + "_" + this.props.id);
  }

  getNews() {
    this.props.onClick();
  }

  onErrorImageLoad() {
    $("#img_" + this.props.id).attr("src", "/assets/images/no_image.png");
  }

  render() {
    return (
      <div className="single-blog-post d-flex align-items-center mb-5">
        <div className="post-thumbnail project">
          <a onClick={() => this.getNews()} style={{ cursor: "pointer" }}>
            <div className="img">
              {(this.props.image === undefined ||
                this.props.image === null) && (
                <img
                  src="/assets/images/no_image.png"
                  data-desktop-image="/assets/images/no_image.png"
                  data-tablet-image="/assets/images/no_image.png"
                  data-mobile-image="/assets/images/no_image.png"
                  alt="new-block"
                />
              )}
              {this.props.media_type === 0 && (
                <img
                  id={`img_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src=""
                  data-desktop-image={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-tablet-image={apiConstant.tablet(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-mobile-image={apiConstant.mobile(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  alt="new-block"
                />
              )}
              {this.props.media_type === 1 && (
                <div>
                  <img
                    id={`img_${this.props.id}`}
                    onError={() => this.onErrorImageLoad()}
                    src={apiConstant.thumbnail(
                      this.props.business,
                      this.props.id,
                      getVideoThumbFileName(this.props.image)
                    )}
                    alt="new-block"
                  />
                </div>
              )}
            </div>
          </a>
          {this.props.media_type === 1 && (
            <a
              href={apiConstant.desktop(
                this.props.business,
                this.props.id,
                this.props.image
              )}
              className="play-video video-icon"
              onClick={() =>
                logApi.log({
                  title: this.props.title,
                  lang: localStorage.getItem("language"),
                  type: "동화상",
                })
              }
            >
              <i className="fa fa-play" aria-hidden="true"></i>
            </a>
          )}
        </div>

        <div className="post-content">
          <span
            onClick={() => this.getNews()}
            style={{
              textIndent:
                localStorage.getItem("language") === "cn"
                  ? "21.25pt"
                  : "14.5pt",
            }}
            dangerouslySetInnerHTML={{
              __html:
                this.props.title === undefined || this.props.title === null
                  ? ""
                  : this.props.title,
            }}
            className="post-title"
          ></span>
          <div
            className="post-description ellipsis multiline"
            id={`desc_${this.props.business}_${this.props.id}`}
            style={{ marginBottom: "20px" }}
            dangerouslySetInnerHTML={{ __html: this.props.description }}
            caption={UTILS.symbolingText(this.props.description)}
          />
          <span
            onClick={() => this.getNews()}
            className="btn mini btn-primary btn-outline-primary px-2 py-1"
          >
            {lang("read_more")}
          </span>
        </div>
      </div>
    );
  }
}

export default NewsBlock;
